<template>
  <a-form class="private-info-form" :form="form">
    <full-name-input v-model="fullName" :disabled="true" />
    <email-input v-model="email" :disabled="true" />
    <div class="row">
      <a-input :placeholder="$t('flat')" v-model="address1" @blur="handleSave" />
    </div>
    <div class="row">
      <a-input :placeholder="$t('address')" v-model="address2" @blur="handleSave" />
    </div>
    <div class="row">
      <a-input
        class="postcode-input"
        :placeholder="$t('postcode')"
        v-model="zip"
        @blur="handleSave"
      />
      <spacer type="small" />
      <a-input :placeholder="$t('town')" v-model="city" @blur="handleSave" />
    </div>

    <div class="row mt-m">
      <a :href="emailPreferencesUrl">{{$t('change.email.preferences')}}</a>
    </div>

    <div class="button-container">
      <div class="item-wrapper">
        <fake-save-button class="fake-button" :message="$t('save.private.info')"></fake-save-button>
      </div>
    </div>
  </a-form>
</template>

<script>
import EmailInput from '@/components/common/EmailInput.vue';
import FullNameInput from '@/components/common/FullNameInput.vue';
import FakeSaveButton from '@/components/account/FakeSaveButton.vue';
import Spacer from '@/components/common/Spacer.vue';

import { mapActions } from 'vuex';
import {
  SAVE_PRIVATE_INFO,
  UPDATE_PRIVATE_INFO,
} from '@/store/privateInfo/actionTypes';
import { assignWithGetters } from '@/services/utils';
import { URLS } from '@/constants';

const mapPrivateInfoFields = (fileds) => {
  return fileds.reduce(
    (res, field) =>
      assignWithGetters(res, {
        [field]: {
          get() {
            return this.$store.getters.privateInfo[field];
          },
          set(value) {
            return this.$store.dispatch(UPDATE_PRIVATE_INFO, {
              [field]: value,
            });
          },
        },
      }),
    {},
  );
};

export default {
  components: {
    EmailInput,
    FullNameInput,
    FakeSaveButton,
    Spacer,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'privateInfo' });
  },
  methods: {
    ...mapActions({
      save: SAVE_PRIVATE_INFO,
    }),
    handleSave(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err) => {
        if (!err) {
          this.save(this.dataToSave);
        }
      });
    },
    onFullNameChange({ firstName, lastName }) {
      this.firstName = firstName;
      this.lastName = lastName;
    },
  },
  computed: {
    ...mapPrivateInfoFields([
      'email',
      'firstName',
      'lastName',
      'address1',
      'address2',
      'zip',
      'city',
    ]),
    fullName: {
      get() {
        return {
          firstName: this.firstName,
          lastName: this.lastName,
        };
      },
      set(value) {
        this.firstName = value.firstName;
        this.lastName = value.lastName;
      },
    },
    dataToSave() {
      return {
        address1: this.address1,
        address2: this.address2,
        zip: this.zip,
        city: this.city,
      };
    },
    emailPreferencesUrl() {
      return URLS.EMAIL_PREFERENCES;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.row {
  display: flex;
  margin-bottom: 16px;
}

.ant-row {
  flex: 1;
}

.button-container {
  display: flex;
  justify-content: center;
  flex: 0 100%;
}

.item-wrapper {
  flex: 0 100%;
  margin: 16px 0;
}

@media (max-width: $header-breakpoint) {
  .item-wrapper {
    max-width: $page-mobile-small-breakpoint;
  }

  .fake-button {
    width: 100%;
  }
}

@media (max-width: $login-base-breakpoint) {
  .row {
    flex-direction: column;
  }

  .postcode-input {
    margin-bottom: 15px;
  }
}

.mt-m {
  margin-top: 30px;
}
</style>

<style lang="scss">
.private-info-form {
  .ant-form-item {
    margin-bottom: 10px;
  }
}
</style>
